import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../styles/theme";
import GeographyChart from "../../../components/GeographyChart";
import BarChart from "../../../components/BarChart";
import StatBox from "../../../components/StatBox";
import ProgressCircle from "../../../components/ProgressCircle";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [datadis, setDataDis] = useState([]);
  const [dataStaff, setDataStaff] = useState([]);
  const [datafund, setDatafund] = useState([]);
  const staff_type = localStorage.getItem('staff_type');
  const mobile_number_login = localStorage.getItem("mobile_number_login");




  useEffect(() => {
  
      axios
        .get(`${BaseUrl}/api/getInventoryBalances`, {
          withCredentials: true,
        })
        .then((res) => {
          setDatafund(res.data.data)
        });
    },[]);
    useEffect(() => {
    
          axios
            .get(`${BaseUrl}/api/getAllDistributorStaff`, {
              withCredentials: true,
         
            })
            .then((res) => {
              setDataDis(res.data.data);
            })
            .catch((err) => {});
        },[]);
   
  
    
    useEffect(() => {
     
        axios
          .get(`${BaseUrl}/api/getAllStaffCount`, {
            withCredentials: true,
          })
          .then((res) => {
            setDataStaff(res.data.data);
          })
          .catch((err) => {});
      
    }, []);
  
    useEffect(() => {

        axios
          .get(`${BaseUrl}/api/getAllDistributorStaff`, {
            withCredentials: true,
          })
          .then((res) => {});
      
    }, []);
  
 
  return (
    <div className="main-div">
      <h3 className="titlepage"> لوحة تحكم تطبيق ليرتنا كاش</h3>
    {staff_type == "Admin" &&
      mobile_number_login == "0950555563" ?(
      <Box m="5px 5px 0px 5px">
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="140px"
          gap="20px"
        >
          <Box
            gridColumn="span 3"
            backgroundColor={colors.white[200]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            className="progress-dashboard"
          >
            <StatBox title={datadis}  prtitele={"build"} subtitle="عدد مراكز الخدمات" />
          </Box>
          <Box
            gridColumn="span 3"
            backgroundColor={colors.white[200]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            className="progress-dashboard"
          >
            <StatBox
              title={dataStaff}
              prtitele={"users"}
              subtitle="عدد المستخدمين"
            />
          </Box>
          {datafund && datafund.map((e)=>(
          <Box
            gridColumn="span 3"
            backgroundColor={colors.white[200]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            className="progress-dashboard"
          >
            <StatBox
              title={e.balance}
              prtitele={(e.fund.fund_name == 'رصيد وحدات ام تي ان' || e.fund.fund_name == 'وحدات Syriatel ') ?  "unit" : (e.fund.fund_name == 'MTN كاش' || e.fund.fund_name == 'Syriatel كاش') ?'cash': (e.fund.fund_name == 'فاتورة MTN' || e.fund.fund_name == 'فاتورة Syriatel') ?'bill':(e.fund.fund_name == 'ليرتنا كاش') ?'cash':'' }
              subtitle={e.fund.fund_name}
            />
          </Box>
    ))}
         
        </Box>
      </Box>
    ):(
      <Box m="5px 5px 0px 5px">
       <Typography className="title-top">شكرا لاختيارك لنا كشريك موثوق به</Typography>
       <Typography className="title-bottom">أنت لست مجرد عميل. أنت جزء من عائلتنا. نحن ملتزمون ببناء علاقة قوية وتقديم خدمة استثنائية تتجاوز توقعاتك</Typography>
       <Typography className="title-bottom">نحن ملتزمون بنجاحك وسنعمل  لتلبية احتياجاتك   وتقديم الدعم المستمر </Typography>

    
      
    
      </Box>
    )}
     
    </div>
  );
};

export default Dashboard;
